import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { withRouter } from 'react-router';

import { actions } from '../../shared/store.js';
import SuccessStoriesService from './success-stories.service.js';
import SuccessStoryCard from './success-story-card.component.js';
import { MainTitle } from '../../components/ui-toolkit/typography.js';
import NoDataComponent from '../../components/no-data-component/no-data.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './success-stories.scss';

class SuccessStoriesPage extends Component {
	static prefetchData = async language => SuccessStoriesService.getListSuccessStories({ lang: language });

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { successStories, setLoading } = this.props;

		if (!successStories) {
			ScrollToTop();
			this.fetchListSuccessStories();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		if (language.value !== prevProps.language.value) {
			ScrollToTop();
			this.fetchListSuccessStories();
		}
	}

	fetchListSuccessStories() {
		const { setSuccessStories, language, setLoading } = this.props;

		setLoading(true);
		SuccessStoriesPage.prefetchData(language.value)
			.then((data) => {
				setSuccessStories(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const {
			successStories,
			intl: { formatMessage },
			addresses,
			phones,
			generalData,
		} = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return <NotImplemented title="Success Stories" />;
		}

		return (
			<div id="success-stories">
				<div className="container container-fluid">
					<MainTitle>
						<FormattedMessage id="success-stories-list.title" />
					</MainTitle>
					<div className="row stories-container">
						{!successStories || successStories.length === 0 ? (
							<NoDataComponent
								title={formatMessage({
									id: 'success-stories-list.no-results.title',
								})}
								message={formatMessage({
									id: 'success-stories-list.no-results.message',
								})}
								link="/"
								buttonLabel={formatMessage({ id: 'button.goToHome' })}
							/>
						) : (
							successStories.map(story => (
								<div className="col-xs-12 col-sm-6 col-md-4" key={story.id}>
									<SuccessStoryCard story={story} />
								</div>
							))
						)}
					</div>
				</div>
				<Seo
					title={formatMessage({ id: 'navigation.successStories' })}
					description={formatMessage({ id: 'navigation.successStories' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.successStories' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/success-stories"
												}
											]
										}
									]
								}`}
				/>
			</div>
		);
	}
}

const mapToProps = ({ language, successStories, addresses, phones, generalData }) => ({
	language,
	successStories,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(withRouter(injectIntl(SuccessStoriesPage)));

export { SuccessStoriesPage };
